import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import { Alert, AlertTitle, Card, Grid, IconButton } from "@mui/material";
import Loading from "../../../load/loading";
import DateHora from "../../../utils/dateHora";
import TempoPassado from "../../../utils/tempoPassado";
import FichaEstabelecimento from "../fichaEstabelecimento";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { AutorizacaoPDF } from "../exports/autorizacao";
import Paginacao from "../../../utils/paginacao";
import { useSearchParams } from "react-router-dom";
import GraficoAutorizacoes from "../../../utils/graficoAutorizacoes";
import InfoFieldGroup from "../../../utils/InfoField/InfoFieldGroup";
import ButtonLeft from "../../../utils/buttonLeft";
import EditAutorizacaoExercicio from "./editAutorizacaoExercicio";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

const prepararDadosGraficoPorMes = (dados) => {
    const meses = [
        "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
        "Jul", "Ago", "Set", "Out", "Nov", "Dez"
    ];

    const contagemPorMes = meses.map((mes, index) => ({
        mes,
        mesIndex: index,
        total: 0
    }));

    dados.forEach(item => {
        const data = new Date(item.createdAt);
        const mesIndex = data.getMonth(); // 0 a 11
        contagemPorMes[mesIndex].total += 1;
    });

    return contagemPorMes;
};

const prepararDadosPorProvincia = (dados: any[]) => {
    const mapa: Record<string, number> = {};

    dados.forEach(item => {
        const provincia = item.provincia || "Sem província";

        mapa[provincia] = (mapa[provincia] || 0) + 1;
    });

    const totalGeral = Object.values(mapa).reduce((a, b) => a + b, 0);

    return Object.entries(mapa).map(([provincia, total]) => ({
        provincia,
        total,
        percentagem: totalGeral
            ? Number(((total / totalGeral) * 100).toFixed(1))
            : 0
    }));
};

export default function AutorizacoesExercicioEmitidas({ estabelecimento, geral }) {
    const [autorizacoes, setAutorizacoes] = useState('');
    const [configLista, setConfigLista] = useState('');
    const [searchParams] = useSearchParams();
    const [page, setPage] = useState(searchParams.get("page"));
    const [perPage, setPerPage] = useState(20);
    const [anos, setAnos] = useState('');
    const [dadosGrafico, setDadosGrafico] = useState('');
    const [chartDataProvincia, setChartDataProvincia] = useState([]);
    const [isEdit, setIsEdit] = useState(false);

    const anoAtual = new Date().getFullYear();
    const anoGrafico = anos ? Number(anos) : anoAtual;

    useEffect(() => {
        setAutorizacoes('')

        api.get(`/autorizacaos?estabelecimentoId=${estabelecimento?._id ?? ''}&page=${page}&perPage=${perPage}`)
            .then(response => {

                setAutorizacoes(response.data.autorizacaos);
                setConfigLista(response.data);
            }).catch(err => { '' })
    }, [estabelecimento?._id, page, perPage]);

    useEffect(() => {
        if (configLista.totalItems) {
            api.get(`/autorizacaos?perPage=${configLista.totalItems}`)
                .then(response => {
                    const dadosAnoAtual = response.data.autorizacaos.filter((item) => {
                        const createdAt = new Date(item.createdAt);
                        return createdAt.getFullYear() === anoGrafico;
                    });

                    setDadosGrafico(prepararDadosGraficoPorMes(dadosAnoAtual));

                    const dadosProvinciaOrdenados = prepararDadosPorProvincia(dadosAnoAtual).sort((a, b) => b.total - a.total);
                    setChartDataProvincia(dadosProvinciaOrdenados)
                }).catch(err => { '' })
        }
    }, [configLista]);

    const imprimirPdf = async (dado) => {
        const pdfGerarAquivo = await AutorizacaoPDF(dado);
        pdfGerarAquivo.print();
    };

    return (
        autorizacoes
            ?
            <>
                {geral &&
                    <Card sx={{ marginBottom: 2 }}>
                        {dadosGrafico ? <GraficoAutorizacoes chartData={dadosGrafico} ano={anoGrafico} chartDataProvincia={chartDataProvincia} /> : <Loading text='Carregando dados, aguarde...' />}
                    </Card>
                }
                <Grid container spacing={2}  >

                    {autorizacoes.map((autorizacao) =>
                        <Grid item key={autorizacao._id} xs={12} sm={geral ? 6 : 12}>

                            <Card style={{ padding: 20, marginBottom: '10px' }}>
                                <HeaderGestorConfigs
                                    menu={true}
                                    autorizacao={autorizacao}
                                    generatePDF={imprimirPdf}
                                    configArea={'autorizacaoExercio'}
                                    setIsEdit={setIsEdit}
                                // title={geral? :''}
                                />

                                {isEdit === autorizacao?._id &&
                                    <EditAutorizacaoExercicio
                                        autorizacao={autorizacao}
                                        estabelecimento={autorizacao?.estabelecimento}
                                        setAutorizacoes={setAutorizacoes}
                                        setIsEdit={setIsEdit}
                                    />
                                }

                                <div style={{ padding: 10, position: 'relative' }}>
                                    <IconButton size="large" onClick={() => imprimirPdf(autorizacao)} style={{ position: 'absolute', right: 0 }}>
                                        <img src="/img/icones/licenciamentoicon.svg" alt="autor.." width={30} />
                                    </IconButton>

                                    <InfoFieldGroup
                                        // submit={submitEdit}
                                        // data={editDados}
                                        // handleChange={handleChange}
                                        editable={false}
                                        setIsEdit={() => { }}
                                        isEdit={false}
                                        load={false}
                                        fields={
                                            [
                                                { label: 'Nº de Autorização', value: autorizacao?.estabelecimento?.numeroAutorizacao, key: 'numeroAutorizacao', onChange: '(v) => setEditDados({ ...editDados, numeroAutorizacao: v.target.value })' },
                                                { label: 'Tipo de Autorização', value: autorizacao?.tipoAutorizacao, key: 'tipoAutorizacao', onChange: '(v) => setEditDados({ ...editDados, tipoAutorizacao: v.target.value })' },
                                                { label: 'Restrição', value: autorizacao?.restricaoAutorizacao, key: 'restricaoAutorizacao', onChange: '(v) => setEditDados({ ...editDados, restricaoAutorizacao: v.target.value })' },
                                                { label: 'Data de Emissão', value: <DateHora date={autorizacao?.dataEmissao} />, key: 'dataEmissao' },
                                                { label: 'Ultima actualizacao', value: <DateHora date={autorizacao?.updatedAt} />, key: 'updatedAt' },
                                                { label: 'Data de Expiração', value: <DateHora date={autorizacao?.dataExpiracao} />, key: 'dataExpiracao' },
                                                { label: 'Emitido por', value: autorizacao?.por?.dadosPessoais?.nome, key: 'emitidoPor' },
                                                { label: 'Tempo de actividade termina', value: <TempoPassado date={autorizacao?.dataExpiracao} />, key: 'dataExpiracao' },
                                                { label: 'Director(a) Geral em exercício', value: autorizacao?.directorGeral?.dadosPessoais?.nome, key: 'directorGeral' },
                                            ]
                                        } />

                                    <ButtonLeft title={'Ver'} funcao={() => imprimirPdf(autorizacao)} />
                                </div>

                                {geral && <FichaEstabelecimento editable={false} menu={false} estabelecimento={autorizacao?.estabelecimento} />}
                            </Card>
                        </Grid>
                    )}

                    {geral &&
                        <Card style={{ marginBottom: 10, width: '99%' }}>
                            <Paginacao
                                configLista={configLista}
                                lista={autorizacoes}
                                page={page}
                                setPage={setPage}
                                setPerPage={setPerPage}
                            // setOrder={setOrder}
                            />
                        </Card>
                    }
                    {autorizacoes.length < 1 &&
                        <Alert severity="warning">
                            <AlertTitle>Para este estabelecimento ainda não foi emitida nenhuma Autorização de Exercício pelo sistema.</AlertTitle>
                        </Alert>
                    }
                </Grid>
            </>
            :
            <Loading />
    )
}